import { useQuery } from "@tanstack/react-query";
import { userBalanceDetailsQueryKey } from "@/features/balance/utils/user-balance-details-query";
import { useAccessToken } from "@/hooks";
import { createAuthenticatedApi } from "@/lib/utils";
import { BalanceApi } from "@/openapi/generated";

interface UseBalanceByUserIdDetailsGetProps {
  userId: number;
  enabled?: boolean;
}

export const useBalanceByUserIdDetailsGet = ({
  userId,
  enabled = true,
}: UseBalanceByUserIdDetailsGetProps) => {
  const accessToken = useAccessToken();

  const {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    refetch,
    isFetching,
  } = useQuery({
    queryKey: userBalanceDetailsQueryKey(userId),
    queryFn: async () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(BalanceApi, accessToken);
      return service.apiBalanceUserIdDetailsGet({
        id: userId,
      });
    },
    enabled: enabled !== false && !!accessToken && userId > 0,
    staleTime: 2 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    refetch,
    isFetching,
  };
};
